import jwt_decode from "jwt-decode";

export const isAuthenticated = () => {
  let tokenValid = false;

  try {
    if (localStorage.getItem("tokenRestaurant").replace(/[\""]+/g, "")) {
      if (
        Date.now() >=
        jwt_decode(
          localStorage.getItem("tokenRestaurant").replace(/[\""]+/g, "")
        ).exp *
          1000
      ) {
        tokenValid = false;
      } else {
        tokenValid = true;
      }
    }
  } catch (error) {
    tokenValid = false;
  }
  return tokenValid;
};
